import { RootState } from 'store/store';

export const selectStbRequest = (state: RootState) => state.STBRequest.stbRequest;
